import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class BLUV2EditLotModelModel extends BaseModel {
  lot_no = null;

  rules = {
    lot_no: 'min_value:1|required'
  };

  attributeLabels = {
    lot_no: i18n.t('Lot No')
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}

